// https://branch.invisionapp.com/console/share/E51SX0HERW/494177337
import createPalette from '@mui/material/styles/createPalette';
import { Colors } from '../Colors';
export const palette = createPalette({
    mode: 'light',
    common: {
        black: Colors.primary.contrastBlack,
        white: Colors.primary.contrastWhite,
    },
    primary: Object.assign({ contrastText: Colors.primary.contrastWhite }, Colors.primary),
    secondary: {
        contrastText: Colors.primary.contrastWhite,
        dark: Colors.text[900],
        main: Colors.text[700],
        light: Colors.text[600],
    },
    error: Object.assign({ contrastText: Colors.primary.contrastWhite }, Colors.error),
    warning: Object.assign({ contrastText: Colors.primary.contrastWhite }, Colors.warning),
    info: Object.assign({ contrastText: Colors.primary.contrastWhite }, Colors.primary),
    success: Object.assign({ contrastText: Colors.primary.contrastWhite }, Colors.success),
    text: {
        primary: Colors.text[900],
        secondary: Colors.text[600],
        disabled: Colors.text[600],
    },
    background: {
        default: Colors.gray[0],
        paper: Colors.primary.contrastWhite,
    },
    divider: Colors.gray[200],
});
//# sourceMappingURL=Palette.constants.js.map